import React from 'react';

import AboutUsMain from './AboutUsMain';
import ContactDetails from './ContactDetails';
import AboutCeoSection from './AboutCeoSection';

const AboutUsSection = ({ data }: { data: any }): JSX.Element => {
  return (
    <>
      <AboutUsMain data={data} />
      <AboutCeoSection data={data} />
      <ContactDetails data={data} />
    </>
  );
};

export default AboutUsSection;
